import React, { forwardRef } from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import MediaQuery from 'react-responsive';
import Sticky from 'react-stickynode';
import { getContext } from '@fiverr-private/fiverr_context';
import { MEDIA_GRID_MD } from '../../utils/constants';
import inStickySidebarExperiment from '../../utils/experiments/stickySidebar';
import SafePureComponentWrapper from '../shared/SafePureComponent';
import { inAllowedCategory as inAllowedCustomOrderCategory } from '../../common/customOrder';
import SidebarContent from './SidebarContent';

import './style.scss';

// The offset from the top of window where the top of the element will be, when sticky state is triggered
// in our case, we have the TopNav.height = 54 and .gig-page.padding = 32
const REACT_STICKY_TOP_OFFSET = 86;

const Sidebar = forwardRef(({
    customOrder,
    studio,
    onComparePackagesClick,
    useStickyLayout,
    containerClassName = '',
    general
}, ref) => {
    const { abTests } = getContext();
    const { categoryId, subCategoryId } = general;

    const renderReactSticky = inStickySidebarExperiment(abTests) &&
        !inAllowedCustomOrderCategory(categoryId, subCategoryId);

    const contentProps = {
        customOrder,
        studio,
        onComparePackagesClick,
        useStickyLayout
    };

    const sidebarClassName = 'sidebar';
    const sidebarStickyStyleClassName = classNames(
        sidebarClassName,
        'style-sticky'
    );

    return renderReactSticky ?
        (
            <MediaQuery query={`(min-width: ${MEDIA_GRID_MD})`}>
                {(matches) => matches ?
                    <Sticky enabled={useStickyLayout}
                        top={REACT_STICKY_TOP_OFFSET}
                        innerClass="inner-sticky"
                        bottomBoundary={`.${containerClassName}`}
                        className={classNames(sidebarClassName, 'react-sticky')}>
                        <SidebarContent {...contentProps}/>
                    </Sticky>:
                    <SidebarContent {...contentProps} className={sidebarStickyStyleClassName}/>
                }
            </MediaQuery>
        ):
        (<SidebarContent {...contentProps} setRef={ref}
            className={classNames(sidebarStickyStyleClassName, { 'poly-sticky': useStickyLayout })}/>);

});

Sidebar.displayName = 'Sidebar';

Sidebar.propTypes = {
    studio: object,
    customOrder: object,
    onComparePackagesClick: func,
    useStickyLayout: bool,
    containerClassName: string,
    general: object
};

export { Sidebar };
export default SafePureComponentWrapper(Sidebar);
